import { RequirementFriendlyDescription } from "../../requirementFriendlyDescription.js";
import { soadT4Part1DataSchema } from "../../schemas/index.js";
export const soadT4Part1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [],
            teamType: ["soad"],
            friendlyDescription: RequirementFriendlyDescription.approvedClinicianOrRegisteredMedicalPractitioner,
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            field: "practitioner",
            label: "SOAD name and address",
            hideWarningBanners: true,
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I am a registered medical practitioner appointed for the purposes of Part 4 of the Act (a SOAD).",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "I certify that the patient named above has attained the age of 18 years.",
            ],
        },
        {
            type: "textbox",
            field: "treatment",
            label: "Enter description of treatment or plan of treatment. Indicate clearly if the certificate is only to apply to any or all of the treatment for a specific period",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [part5?.planAuthorisedEct, part5?.timeLimitCertificateDuration]
                        .filter(Boolean)
                        .join("\n\n");
                },
                label: "Copy from SRF Treatment plan",
            },
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(a) I certify that this patient is capable of understanding the nature, purpose and likely effects of the above stated treatment or plan of treatment.",
            ],
        },
        {
            type: "label",
            showStaticLabel: true,
            label: [
                "(b) I certify that this patient has consented to that treatment.",
            ],
        },
    ],
    dataSchema: soadT4Part1DataSchema,
};
export const soadT4V1Base = {
    id: "mha-soad-t4",
    category: "soad",
    version: "1.0",
    status: "active",
    formName: "T4",
    section: "58A(3)",
    parts: [soadT4Part1Template],
    description: "Certificate of consent to treatment (patients at least 18 years old) ",
    extractGenericData: () => ({}),
};
//# sourceMappingURL=soad-t4.js.map